import { SearchInput } from '../shared';
import { SortOrder, CustomerSortType } from '../enums';

export class GetCustomersInput extends SearchInput<CustomerSortType> {
    constructor() {
        super(CustomerSortType.Name);
        this.sortOrder = SortOrder.Ascending;
    }
}
